var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_vm._v("\n    Profi-Bank.org © "+_vm._s(_vm.year)+" "),_c('a',{attrs:{"href":"http://professional-group.org","target":"_blank"}},[_vm._v("SIIB Professional Group")]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"float-right"},[_c('a',{attrs:{"href":"http://prosperity.one","target":"_blank"}},[_vm._v("Consortium Prosperity SE")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a422125c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 356
// module chunks = 1